const initialState = {
  wsFastAnswers: [],
  msnFastAnswers: [],
  igFastAnswers: [],
  ttFastAnswers: [],
  commentsFastAnswers: [],
  fastAnswerSelected: null,
  sendFastAnswer: false,
  copyFastAnswerToInput: false
};

const fastAnswersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SHORTCUT_WHATSAPP_FAST_ANSWERS':
      return {
        ...state,
        wsFastAnswers: action.data.templates.data
      };
    case 'SET_SHORTCUT_MESSENGER_FAST_ANSWERS':
      return {
        ...state,
        msnFastAnswers: action.data.templates.data
      };
    case 'SET_SHORTCUT_INSTAGRAM_FAST_ANSWERS':
      return {
        ...state,
        igFastAnswers: action.data.templates.data
      };
    case 'SET_SHORTCUT_COMMENTS_FAST_ANSWERS':
      return {
        ...state,
        commentsFastAnswers: action.data.templates.data
      };
    case 'SET_SHORTCUT_TIKTOK_FAST_ANSWERS':
      return {
        ...state,
        ttFastAnswers: action.data.templates.data
      };
    case 'SET_SEND_FAST_ANSWER':
      return {
        ...state,
        fastAnswerSelected: action.data.answer,
        sendFastAnswer: action.data.send,
        copyFastAnswerToInput: false // Reset copy state
      };
    case 'SET_COPY_FAST_ANSWER_TO_INPUT':
      return {
        ...state,
        fastAnswerSelected: action.data.answer,
        copyFastAnswerToInput: action.data.copy,
        sendFastAnswer: false // Reset send state
      };
    case 'RESET_FAST_ANSWER_ACTIONS':
      return {
        ...state,
        fastAnswerSelected: null,
        sendFastAnswer: false,
        copyFastAnswerToInput: false
      };
    case 'CREATE_FAST_ANSWER':
      return {
        ...state,
        fastAnswerSelected: {}
      };
    case 'START_SAVING_FAST_ANSWER_REQUEST':
      return {
        ...state,
        savingFastAnswer: true
      };
    case 'END_SAVING_FAST_ANSWER_REQUEST':
      return {
        ...state,
        savingFastAnswer: false
      };
    default:
      return state;
  }
};

export default fastAnswersReducer;
